module.exports = __webpack_public_path__ + "img/pingmu.5de0d746.png";